<template>
  <div>
    <form data-vv-scope="assign-approval" >
      <list-group-users
        class="w-100"
        autocomplete
        label="Usuarios de la oficina"
        name="resendSubject"
        data-cy="user-resend"
        v-model="resendSubject.id"
        :parent-value="officeSelected"
        ref="resendName"
        v-validate="'required'"
        :danger="errors.has('assign-approval.resendSubject')"
        :danger-text="errors.first('assign-approval.resendSubject')"
      />
    </form>
    <b-overlay :show="loading">
      <div class="text-right mt-2">
        <b-button
          class="mr-2"
          data-cy="assign-flows-button"
          variant="primary"
          size="sm"
          @click="assignFlows"
        >
          Asignar expedientes
        </b-button>
      </div>
    </b-overlay>
  </div>
</template>
<script>

import { mapActions } from 'vuex';

import ListGroupUsers from '@/febos/chile/lists/components/ListGroupUsers';
import { stepTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';

export default {
  components: {
    ListGroupUsers
  },
  data() {
    return {
      resendSubject: {},
      loading: false,
      comment: ''
    };
  },
  computed: {

  },
  methods: {
    ...mapActions('Approvals', [
      'processMassiveFiles'
    ]),
    makeObjectRequest() {
      const action = 'reenviar';
      const name = this.$refs.resendName && this.$refs.resendName.getOption().label;
      const body = {
        accion: 'cl_aprobaciones',
        nombre: 'Asignación Masiva de documentos',
        metodo: 'SERIE',
        ejecutarDeInmediato: 'N',
        comunes: {
          comentario: {
            accion: action,
            comentario: this.comment
          },
          documentos: [],
          pais: 'cl',
          functionClass: 'cl.febos.aprobaciones.acciones.flujo.masiva.HandlerClAprobacionesProcesarFlujoMasiva',
          requestClass: 'cl.febos.aprobaciones.acciones.flujo.masiva.RequestClAprobacionesProcesarFlujoMasiva',
          responseClass: 'cl.febos.aprobaciones.acciones.flujo.masiva.ResponseClAprobacionesProcesarFlujoMasiva'
        },
        payload: this.selectedFlows.map((flow) => ({
          requestAprobacion: {
            estado: action.toUpperCase(),
            pasoId: flow.pasoActualId,
            ejecucionId: flow.idAprobacion,
            aprobacionId: '0',
            temporalUsuario: name,
            temporalUsuarioId: this.resendSubject.id,
            temporalContinuar: true,
            tipoPaso: stepTypesCode.oficial
          }
        }))
      };

      return { body };
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async assignFlows() {
      const isValid = await this.validateForm('assign-approval');
      if (!isValid) {
        return;
      }
      this.loading = true;
      const response = await this.processMassiveFiles(this.makeObjectRequest());
      this.$bvToast.toast(
        `${response.mensaje}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.loading = false;
      this.$emit('close-modal');
    }
  },
  props: {
    officeSelected: { type: String },
    selectedFlows: { type: Array, required: true }
  }
};
</script>
